import React, { useState, Fragment, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
// import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

// import Input from '@material-ui/core/Input';
// import Button from '@material-ui/core/Button';
// import InputLabel from '@material-ui/core/InputLabel';
// import InputAdornment from '@material-ui/core/InputAdornment';
// import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Switch from '@material-ui/core/Switch';
// import Grid from '@material-ui/core/Grid';
// import ButtonComp from '../../button';
import Typography from '@material-ui/core/Typography';
import './styles.css';
import { CommonConfig } from '../../../config/common-config';

const useStyles = makeStyles((theme) => ({
    // root: {
    //     display: 'flex',
    //     flexWrap: 'wrap',
    // },
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: '25ch',
    },
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    toggleCss: {
        marginLeft: '0',
        marginRight: '0',
    },
    chekListAddBtn: {
        marginLeft: '20px',
        borderColor: '#5a58b1',
        color: '#5a58b1',
        borderRadius: '5px',
        width: '100px',
        padding: '5px',
        background: 'transparent',
    },
}));

export default function AdditionalQuestions() {
    const serviceIdSelected = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName.tennantName);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;

    const usersData = [];
    const [users, setUsersData] = useState(usersData);
    const [usersError, setusersError] = useState(false);
    const imcNameSelected = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[5].branchName;
    // const classes = useStyles();

    const getadditionalQuestions = (bearerToken) => {
        axios
            .get(`${CommonConfig.dev.baseUrl1}/api/itr/additional-question/${(usertype === 'Ultimate Client' || usertype === 'EM') ? tennantDetails : imcNameSelected}/${serviceIdSelected}`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data.length > 0) {
                    setUsersData(response.data);
                } else {
                    setusersError('No additional Questions added');
                }
            })
            .catch((error) => {
                //console.log(error);
            });
    };
    useEffect(() => {
        if (tennantDetails) {
            getadditionalQuestions(bearerToken);
        }
    }, [tennantDetails]);

    const aQlist = () => (
        <div>
            {users.length === 0 ? 'No Additional Questions added' : ' '}
            {users &&
                users.map((user) => (
                    <li key={user.questionId}>
                        {user.questionText} [{user.isAttachmentRequired === true ? 'Attachment Required' : 'No Attachment'}]
                    </li>
                ))}
        </div>
    );

    return (
        // <Grid container spacing={3} className="main-container">
        // <Grid item xs={12} sm={12}>
        <FormControl fullWidth className="additional-questions">
            <Typography variant="subtitle1" gutterBottom>
                {usersData && aQlist()}
            </Typography>
        </FormControl>
        // </Grid>
        // </Grid>
    );
}
